import { getUserLocationData } from '../../../lib/common/userLocation';
import { getIP } from '../../../lib/api/ipApi';
import { getUtmParams } from '../../../lib/common/utm';
import { randomCodeGenerator } from '../../../lib/common/utm';
import { CAPTURE_LEAD } from '../../../lib/graphql/constants/upGrad/lead.gql';
import UgGradGQL from '../../../lib/graphql/constants/upGrad/gql';
import { tracker } from '../../../lib/events/tracker';
import storeDataToLocal from 'components/layout-a/forms/common/StoreDataToLocalStorage';
import { notify } from '../../../lib/common/notify';

const UpGradSubmitHandler = async (
  data?: any,
  extraData?:
    | {
        leadType?: string;
        static_lead_type?: string;
        page?: string;
        action?: string;
        name?: string;
        label?: string;
        program?: string;
      }
    | any,
  reset?: any
) => {
  // Certifying_authority check
  if (data.certifying_authority?.length) {
    return;
  }

  const dataCopy = {
    ...data,
  };
  delete dataCopy.course_name;
  delete dataCopy.country_name;
  delete dataCopy.city_name;

  // getCurrentLocation
  const location = await getUserLocationData();
  const ipData = await getIP();
  const ipAddress = ipData.ip;
  const utmParams = getUtmParams();
  const randomCode = randomCodeGenerator();
  const defaultData = {
    code: randomCode,
    ip_address: ipAddress,
    utm_parameters: utmParams,
  };

  const formData = { ...defaultData, ...data, ...extraData };

  const captureLeadData = {
    firstName: formData.first_name,
    lastName: formData.last_name,
    email: formData.email,
    phone: formData.phone,
    utmFormId: `${formData.program.split(' ')[0].toUpperCase()}_${formData.leadType}`,
    enableWhatsApp: formData.whatsapp_subscription_status ? 'YES' : 'NO',
    yearsOfExperience: (formData?.leadType == 'MASTER_CLASS_APPLY_NOW' ? formData.user_experience : ''),
    query: formData.query,
    program: formData.program,
    utmMedium: utmParams.UMEDIUM,
    utmSource: utmParams.USOURCE,
    url: formData.page,
    utmCampaign: utmParams.UCAMPAIGN,
    utmTerm: utmParams.UTERM,
    utmContent: utmParams.UCONTENT,
    detectedCity: location.city.name,
    detectedCountry: location.country.name,
    programKey: 'master-lift-upgra-psv2' // default value for ug master class
  };

  const response = await UgGradGQL({
    query: CAPTURE_LEAD,
    variables: { input: { lead: captureLeadData } },
    queryName: 'captureLead',
    queryType: 'mutation',
    context: 'captureLead',
  });

  if (response) {
    // tracker
    tracker({
      trackerType: 'all',
      eventAction: extraData.action,
      eventActionType: 'Submit',
      eventName: extraData.name,
      eventLabel: extraData.label,
      data: { ...data, ...extraData, ...{ leadIdentifier: response?.data?.captureLead?.leadIdentifier }, ...captureLeadData },
    });

    delete data.course_name;
    delete data.country_name;
    delete data.city_name;

    storeDataToLocal(formData);
    reset();
    return { success: true, response: response?.data?.captureLead };
  }
  return notify('error', response);
};

export default UpGradSubmitHandler;
